import { Widget } from '../Widget';
import { ModAccessProperties } from '../mods/modAccess';
import {
  ModBaseWidgetCallbacks,
  ModBaseWidgetProperties,
} from '../mods/modBaseWidget';
import { ModFeedbackServiceProperties } from '../mods/modFeedbackService';
import { ModKLSProperties } from '../mods/modKLS';

export type TransactionViewerProperties =
  | ModBaseWidgetProperties
  | ModAccessProperties
  | ModFeedbackServiceProperties
  | ModKLSProperties;
export type TransactionViewerCallbacks = ModBaseWidgetCallbacks;

export class TransactionViewer extends Widget<
  TransactionViewerProperties,
  TransactionViewerCallbacks
> {
  /**
   * # Transaction Viewer
   * The Transaction Viewer will be used to search for imported transactions,
   * check the assigned labels, correct any incorrect labels, and provide
   * feedback.
   *
   * @param container - parent HTML element where the widget will be injected
   * @param target - URL of the environment from which the widget's JS bundle will be fetched. Use this, for example, when testing features that are only released to the sandbox environment. By default, `https://widget-library-finapi-general-live.finapi.io` is used.
   * @param ownerDocument - parent Document where the widget will be injected. For example, shadow root or document fragment. By default, the default top-level document is used.
   * @param customBundleFileName - allows modifying the filename of the widget's JS bundle that will be fetched. This property is useful during dev mode when widgets are generated together into one `main.js` file.
   */
  constructor(
    container: HTMLElement,
    target?: string,
    ownerDocument?: Document,
    customBundleFileName?: string
  ) {
    super(
      'transactionViewer',
      container,
      target,
      ownerDocument,
      customBundleFileName
    );
  }
}
